/**
 * Dependency imports
 */
import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Box, BoxProps, } from '@mantine/core';

/**
 * Local imports
 */

/**
 * Root
 */
const Root = styled(Box, {
  shouldForwardProp: (prop: PropertyKey) => ![''].includes(prop.toString()),
})<Partial<ClientsCombinedProps>>((props) => css``);

/**
 * Component(s)
 */

/**
 * Clients Component
 */
export interface ClientsProps {
  [prop: string]: any;
}

export type ClientsCombinedProps = ClientsProps & BoxProps;

const Clients: React.FC<ClientsCombinedProps> = (props) => {
  return null;
};

export default Clients;
